<template>
  <balance
      :is-review="true"
      :title="isDialog?' ':title"
      :cols="(isXs)?mobileCols:datatableCols"
      url="reports/balance"
      :getAccountLedgerQuery="getAccountLedgerQuery"
      :getSubAccountLedgerQuery="getSubAccountLedgerQuery"
      :defaultFilters="defaultFilters"
      ref="balance"
  />
</template>

<script>
import datatableCols from "./_datatableCols";
import Balance from "../Balance";

export default {
  name: "AccountReviewBalance",
  components: {Balance},
  props: {
    isDialog: {
      default: false
    },
  },
  data() {
    return {
      datatableCols,
      defaultFilters: {
        level: 0,
        account_type: null,
        cols_count: 4,
        balance_status: "with_transaction",
      },
      mobileCols: {
        cols: [
          {
            text: "نام حساب",
            value: "name",
          },
        ],
      }

    };
  },
  methods: {
    getAccountLedgerQuery(item) {
      return {
        "ledger.account": item.id,
        "ledger.level": `level${item.level}`,
      };
    },
    getSubAccountLedgerQuery(item, subAccount) {
      return {
        "ledger.account": item.id,
        "ledger.floatAccount": subAccount.level == "floatAccounts" ? subAccount.id : null,
        "ledger.level": `level${item.level}`,
      };
    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش مرور حساب ها ')
    },
  }
};
</script>
